import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, ThemeMode } from '@/providers/ThemeProvider';

interface Opt {
  k: ThemeMode;
  Icon: React.ComponentType<{ className?: string }>;
  label: string;
}

const OPTS: Opt[] = [
  { k: 'light',  Icon: Sun,     label: 'Claro' },
  { k: 'dark',   Icon: Moon,    label: 'Escuro' },
  { k: 'system', Icon: Monitor, label: 'Sistema' },
];

export function ThemeToggle() {
  const { mode, setMode } = useTheme();
  return (
    <div
      role="radiogroup"
      aria-label="Modo de tema"
      className="flex items-center gap-0.5 p-1 rounded-lg bg-surface-alt dark:bg-surface-dark-alt border border-line dark:border-line-dark"
    >
      {OPTS.map(o => {
        const active = mode === o.k;
        return (
          <button
            key={o.k}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={o.label}
            title={o.label}
            onClick={() => setMode(o.k)}
            className={[
              'w-7 h-7 rounded-md flex items-center justify-center transition-colors',
              active
                ? 'bg-surface dark:bg-surface-dark text-ink-title dark:text-ink-title-dark shadow-sm-warm dark:shadow-sm-dark'
                : 'text-ink-subtitle dark:text-ink-subtitle-dark hover:text-ink-title dark:hover:text-ink-title-dark',
            ].join(' ')}
          >
            <o.Icon className="w-3.5 h-3.5" />
          </button>
        );
      })}
    </div>
  );
}
